<iot-platform-ui-async-autocomplete
  (reset)="onReset()"
  (search)="onSearch($event)"
  (selectionChanged)="onSelect($event)"
  [autocomplete]="true"
  [clearOnSelect]="clearOnSelect()"
  [data]="filteredTimezones()"
  [debounceTime]="0"
  [disableOnlyOptions]="disableOnlyOptions()"
  [disabled]="disabled()"
  [displaySearchIcon]="false"
  [errorMessage]="errorMessage()"
  [initialItem]="selectedTimezone()"
  [minLength]="0"
  [placeholder]="placeholder() | translate"
  [required]="required()"
  displayKey="key"
  fxFlex
/>
